import React, { useEffect, useRef, useState } from 'react';
import './datePicker.style.scss';
import { __DatePickerProps, __DatePickerRef } from './datePicker.interface';
import { Calendar } from 'react-datepicker2';
import moment, { Moment } from 'moment-jalaali';
import { Calender, Language, ReduxState, TextDirection } from '../../../interface';
import { connect, ConnectedProps } from 'react-redux';
import { OverlayTrigger } from 'react-bootstrap';
import HintText from '../hintText/hintText.index';
import QuestionImage from '../questionImage/questionImage.index';
import { extractTitle } from 'scripts/string';
export interface SLPDatePickerRef extends __DatePickerRef {}


const SLPDatePicker: React.ForwardRefRenderFunction<
    __DatePickerRef,
    ConnectedProps<typeof connector> & __DatePickerProps
> = (props: ConnectedProps<typeof connector> & __DatePickerProps, ref) => {
    const lang = props.lang.utilities;
    const [error, setError] = useState<string>();
    const [value, setValue] = useState<Date | null>(props.defaultValue ? props.defaultValue : null);
    const [isOpen, setOpen] = React.useState(false);
    const [menuWidth, setMenuWidth] = useState<string>();
    const dropRef = useRef<HTMLDivElement>(null);
    const mouseEnter = useRef<boolean>(false);
    const refOpen = useRef<boolean>(false);
    const immediateValue = useRef<Date | null>(value);
    const labelRef = useRef<HTMLLabelElement>(null);
    React.useImperativeHandle(ref, () => ({
        getValue: () => (immediateValue.current ? immediateValue.current : undefined),
        setError: (text) => {
            setError(text);
        },
    }));

    useEffect(() => {
        if (labelRef.current && props.label) labelRef.current.innerHTML = extractTitle(props.label, false);
    }, [props.label]);

    useEffect(() => {
        document.addEventListener('mousedown', handleClick);

        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);

    useEffect(() => {
        refOpen.current = isOpen;
    }, [isOpen]);

    function handleClick() {
        if (refOpen.current && !mouseEnter.current) {
            mouseEnter.current = false;
            setOpen(false);
        }
    }

    function onChangeHandler(changedValued: Moment) {
        const temp = changedValued.format('YYYY/M/D');
        immediateValue.current = new Date(temp);
        setValue(immediateValue.current);
        if (props.onChange) props.onChange(new Date(temp));
        setError(undefined);
        setOpen(false);
    }
    /* function getCustomFormat(inputValue: Date | null, isGregorian: boolean) {
        if (!inputValue) return '';

        return isGregorian ? inputValue.toLocaleDateString() : inputValue.toLocaleDateString('fa-IR');
    } */
    let momentValue;
    if (value) {
        const miladi = value.getFullYear() + '-' + (value.getMonth() + 1) + '-' + value.getDate();
        momentValue = moment(miladi, 'YYYY-M-D');
    }
    let minValue;
    if (props.minDate) {
        const minMiladi =
            props.minDate.getFullYear() + '-' + (props.minDate.getMonth() + 1) + '-' + props.minDate.getDate();
        minValue = moment(minMiladi, 'YYYY-M-D');
    }
    let maxValue;
    if (props.maxDate) {
        const maxMiladi =
            props.maxDate.getFullYear() + '-' + (props.maxDate.getMonth() + 1) + '-' + props.maxDate.getDate();
        maxValue = moment(maxMiladi, 'YYYY-M-D');
    }

    useEffect(() => {
        if (isOpen) setMenuWidth(dropRef.current?.clientWidth.toString());
    }, [isOpen]);

    return (
        <div
            className={`ucheck-SLP-date-picker ${isOpen ? 'show' : ''} ${error ? 'error' : ''}  ${
                props.dir === TextDirection.rtl ? 'rtl-text' : ''
            }`}
            ref={dropRef}
        >
            <div className="date-picker-header">
                {props.required && <span className="required-star">*</span>}
                <span className="counter-span">{props.counter ? props.counter + '- ' : ''}</span>
                <label ref={labelRef} style={{ color: props.labelColor }} />
            </div>
            <QuestionImage src={props.image?.file} />
            <HintText value={props.hint} />
            <OverlayTrigger
                show={isOpen}
                // container={dropRef.current}
                trigger={[]}
                overlay={
                    <div
                        onMouseEnter={() => {
                            mouseEnter.current = true;
                        }}
                        onMouseLeave={() => {
                            mouseEnter.current = false;
                        }}
                        className="ucheck-slp-datepicker-container"
                        style={{ width: menuWidth + 'px' }}
                    >
                        <Calendar
                            min={minValue}
                            max={maxValue}
                            value={momentValue}
                            isGregorian={
                                props.isJalali !== undefined ? !props.isJalali : props.calender === Calender.gregorian
                            }
                            onChange={onChangeHandler}
                        />
                    </div>
                }
                // placement={`${props.direction === Direction.rtl ? 'bottom-start' : 'bottom-end'}`}
                placement="bottom-start"
            >
                <div
                    onClick={() => {
                        if (!isOpen) setOpen(true);
                    }}
                    className="input-container"
                >
                    <input
                        value={
                            value
                                ? !props.isJalali
                                    ? value.toLocaleDateString()
                                    : value.toLocaleDateString('fa-IR')
                                : ''
                        }
                        placeholder={
                            props.placeholder
                                ? props.placeholder
                                : props.formLang === Language.en
                                ? lang.SLPDatePickerPHEn
                                : lang.SLPDatePickerPH
                        }
                        style={{ color: props.color }}
                        readOnly
                    />
                    <i className="ufi ufi-chevron-down" />
                </div>
            </OverlayTrigger>
            {error && <p className="input-error">{error}</p>}
        </div>
    );
};
const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    calender: state.calender,
    lang: state.lang,
});
const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPDatePicker));
